export default function() {
  return window.initialData
}
